import { transformUserAddress } from "../../../../data-transform";

export default function selectedLegalEntityColumnsSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    config.data.forEach(entity => {
        let row = [];
        const rowId = entity.legalEntityId;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            const columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;

            let columnValue = null;

            if (columnDataType === "string") {
                if (columnId === "hpPONumber") {
                    columnValue = entity.hpPONumber || "";
                }
                else if (columnId === "legalCountry") {
                    columnValue = entity.legalCountry || "";
                }
                else if (columnId === "legalEntityId") {
                    columnValue = entity.legalEntityId || "";
                }
                else if (columnId === "legalEntityName") {
                    columnValue = entity.legalEntityName || "";
                }
                else if (columnId === "billingAddress") {
                    columnValue = transformUserAddress(entity.billingAddress).join(", ") || "";
                }
                else if (columnId === "salesContractId") {
                    columnValue = entity.salesContractId || "";
                }
            }

            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
